export default {
    // 法语
    LOCALE_HTML: {
        'msg.language': '法语',
        'msg.title': 'Indicatif régional',
        'msg.type': 'Catégorie de questions',
        'msg.des': 'Description du problème',
        'msg.phone': 'Numéro de portable',
        'msg.regionCode': 'Indicatif régional',
        'msg.email': 'Adresse e-mail',
        'msg.choose': 'Sélectionner une catégorie',
        'msg.detail': 'Détails du message',
        'msg.back': 'Retour',
        'your.msg': 'Veuillez laisser un message',
        'msg.record': 'Message enregistré',
        'msg.success': 'Message avec succès',
        'to.record': 'Aller à la messagerie vocale',
        completed: 'Terminer',
        submit: 'Soumis',
        'success.desc': 'Votre message a été envoyé avec succès, merci',
        'msg.form.input': 'Veuillez entrez',
        'msg.reply': 'Répondre',
        'comment.suc': 'Merci pour votre avis!',
        'comment.fail': 'Echec de la soumission',
        'comment.placeholder':
            'Bienvenue pour les suggestions pour nos services',
        'reply.suc': 'Soumis avec succès',
        'reply.fail': 'Veuillez saisir votre réponse',
        'reply.placeholder': 'Veuillez saisir votre réponse',
        'msg.more': 'Voir plus',
        'msg.collapse': 'Escamoter',
        'msg.myservice': 'Commentaire sur mon service',
        'msg.evaluate': 'Evaluation du service',
        'msg.evaluateTitle': 'Evaluation du service',
        'msg.score': 'Note :',
        'msg.remark': 'Commentaire :',
        'msg.status.created': 'Créé',
        'msg.status.pending': 'En attente de trait',
        'msg.status.processing': 'En train de trait',
        'msg.status.solved': 'Terminé',
        'msg.service.reply': 'Réponse du service client',
        'msg.my.reply': 'Votre Réponse',
        'msg.toast.des': 'Absent de description du problème',
        'msg.toast.type': 'Absent de catégorie de questions',
        'msg.toast.title': 'Absent de titre',
        'msg.toast.none': 'Champ obligatoire',
        'msg.toast.noAnnex': 'Veuillez télécharger les pièces jointes',
        'msg.toast.noEmail': "L'adresse e-mail est obligatoire",
        'msg.toast.noTel': 'Le numéro de portable est obligatoire',
        'msg.toast.noRegionCode': "L'indicatif régional ne peut pas être vide",
        'msg.toast.noZone': 'Veuillez sélectionner un fuseau horaire',
        'msg.toast.noDateTime': "Veuillez sélectionner la date et l'heure",
        'msg.toast.email': 'Veuillez saisir une adresse e-mail correcte',
        'msg.toast.tel': 'Veuillez saisir un numéro de portable correct',
        'msg.toast.regionCode': "Veuillez sélectionner l'indicatif régional",
        'msg.toast.num': 'Veuillez saisir le bon numéro',
        'msg.toast.annex': 'Veuillez télécharger les pièces jointes',
        'msg.toast.char': 'Veuillez saisir les caractères corrects',
        'msg.list.none': 'Pas de données',
        'msg.form.choose': 'Veuillez sélectionner',
        'msg.form.chooseZone': 'Sélectionnez le fuseau horaire',
        'msg.form.chooseTime': "Choisir l'heure",
        'msg.form.chooseDate': 'Choisir la date',
        'msg.form.sure': 'Confirmer',
        'msg.form.search': 'Recherche…',
        'msg.form.uploadError': 'Erreur du format',
        'msg.form.uploadXss':
            'Le téléchargement a échoué, le contenu du fichier contient un script illégal',
        'msg.update.time': 'mis à jour le',
        'msg.replace.images': 'image',

        MSG016: 'résolu',
        MSG017: 'non résolu',
        MSG019: 'soumettre',
        MSG072: "L'étiquette d 'évaluation ne peut pas être vide ! ",
        MSG073: "La langue d'évaluation ne peut pas être vide!",
        MSG074: 'Étiquette:',
        MSG075: 'Est-ce résolu :',
        MSG076: 'Veuillez indiquer si le problème est résolu',
        MSG015: 'Ce ticket a-t-il résolu votre problème ?',

        'file.size.limit': 'La taille du fichier ne peut pas dépasser 50 Mo',
        'detail.file.limit': '15 au max, la taille ne dépasse pas 50 Mo',
        'form.question.des.tip': 'Veuillez saisir la description du problème',
        'form.title.tip': 'Veuillez saisir le titre',
        'form.class.tip': 'Veuillez choisir une catégorie de questions',
        'upload.file': 'Télécharger la pièce jointe',
        'file.count.limit':
            "Vous ne pouvez télécharger que jusqu'à 15 pièces jointes",
        'select.search.placeholder': 'Rechercher le mot-clé',
        'msg.form.sizeError1':
            'Veuillez télécharger des pièces jointes inférieures à 5 Mo',
        'msg.form.sizeError2':
            'Veuillez télécharger des pièces jointes inférieures à 50 M',
        'msg.form.submit': 'En train de soumission',
        'msg.form.upload': 'Téléchargement...',
        'msg.email.tip1': 'Messages introuvables',
        'msg.email.tip2':
            'Si vous avez déjà laissé un message, vous pouvez le vérifier par vérification par e-mail',
        'msg.email.tip3': 'Démarrer la vérification des e-mails',
        'msg.email.noData': 'Pas de données en compte courant',
        'email.verify.tip':
            "Saisissez l'adresse e-mail utilisée pour laisser un message",
        'email.input.placeholder': 'Veuillez entrer votre adresse e-mail',
        'email.submit': 'Envoyer e-mail',
        'email.rules.error': 'Veuillez saisir votre adresse e-mail correcte',
        'email.code.tip':
            "L'e-mail envoyé, veuillez saisir le code de vérification que vous avez reçu",
        'email.code.placeholder': 'Veuillez saisir le code de vérification ',
        'email.code.submit': 'Voir maintenant',
        'email.notFind.customer': 'Informations client introuvables',
        'email.code.wrong':
            'Erreur de votre code de vérification, veuillez le ressaisir',
        'email.code.expired':
            "Le code de vérification a expiré, veuillez revérifier l'e-mail",
        'email.code': 'Le code de vérification ',
        'email.send.frequently':
            'Opérations trop fréquentes, veuillez réessayer plus tard',
        'comment.fail.400133': 'Ce billet a été évalué',
        'not.get.user.info': "Impossible d'obtenir vos informations",
        'user.verify.tip':
            'Vous devez passer la vérification avant de pouvoir voir le contenu de la liste de messages',
        'verify.type.email': 'Vérification de la boîte aux lettres',
        'verify.text': 'Vérification',
        'cancel.text': 'Annulation',
        'get.verify.code': 'Obtenir le Code de vérification',
        'reGet.verify.code': 'Récupération ',
        'verify.by.email.tip':
            'Le Code de vérification sera envoyé par courrier au numéro de compte de la boîte aux lettres que vous avez entré',
        'verify.type.phone': 'Vérification par SMS',
        'phone.placeholder': 'Veuillez entrer le numéro de téléphone portable',
        'verify.by.phone.tip':
            'Le Code de vérification sera envoyé par SMS dans le numéro de téléphone que vous avez entré',
        'phone.error': 'Veuillez entrer le numéro de téléphone portable',
        'phone.errorCode400150': 'Codes de vérification envoyés fréquemment',
        'phone.errorCode400233': 'Le modèle SMS ne peut pas être vide',
        'phone.errorCode400234': 'Solde SMS Marketing insuffisant',
        'phone.errorCode400235': 'Notification SMS Solde insuffisant',
        'phone.errorCode400247':
            'Erreur de configuration du plugin SMS workorder',
        'phone.errorCode4400248': "L'obtention du modèle SMS a échoué",
        'phone.errorCode400249':
            "Ce numéro n'est pas un numéro de téléphone d'utilisateur existant",
        'phone.errorCode400250':
            'Le Code de vérification a expiré, veuillez le récupérer',
        'msg.you.reply': 'Vous a Répondu',
        'msg.no.reply':'pas de réponse',
    },
    LOCALE_REQUEST: {
        400016: "L'obtention des informations sur le bon de travail a expiré, veuillez actualiser !"
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'Supprimer',
                cancel: 'Annuler',
                confirm: 'Confirmer',
                inert: 'Insérer',
                width: 'Largeur',
                height: 'Hauteur'
            },
            controls: {
                clear: 'Effacer',
                undo: 'Annuler',
                redo: 'Refaire',
                fontSize: 'Taille de police',
                color: 'Couleur',
                textColor: 'Texte',
                tempColors: 'Couleurs temporaire',
                backgroundColor: "Couleur d'arrière plan",
                bold: 'Gras',
                lineHeight: 'Hauteur de ligne',
                letterSpacing: 'Espacement des lettres',
                textIndent: 'Indentation du texte',
                increaseIndent: "Augmenter l'indentation",
                decreaseIndent: "Réduire l'indentation",
                italic: 'Italique',
                underline: 'Souligner',
                strikeThrough: 'Barrer',
                fontFamily: "Police d'écriture",
                textAlign: 'Alignement du texte',
                alignLeft: 'Aligner à gauche',
                alignCenter: 'Aligner au centre',
                alignRight: 'Aligner à droite',
                alignJustify: 'Justifier',
                floatLeft: 'Déplacer à gauche',
                floatRight: 'Déplacer à droite',
                superScript: 'Super-script',
                subScript: 'Sous-script',
                removeStyles: 'Supprimer les styles',
                headings: 'Titres',
                header: 'Entêtes',
                normal: 'Normal',
                orderedList: 'Liste ordonnée',
                unorderedList: 'Liste non-ordonnée',
                blockQuote: 'Citation',
                code: 'Code',
                link: 'Insérer un lien',
                unlink: 'Supprimer le lien',
                hr: 'Ligne horizontale',
                media: 'Média',
                mediaLibirary: 'Bibliothêque',
                emoji: 'Emoji',
                fullscreen: 'Plein écran',
                exitFullscreen: 'Quitter le plein écran'
            },
            linkEditor: {
                textInputPlaceHolder: 'Insérer le texte à afficher',
                linkInputPlaceHolder: 'Insérer le lien URL',
                inputWithEnterPlaceHolder:
                    'Insérer le lien URL puis appuyer sur Entrée',
                openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
                removeLink: 'Supprimer le lien'
            },
            audioPlayer: {
                title: 'Lancer le son audio'
            },
            videoPlayer: {
                title: 'Lancer la video',
                embedTitle: 'Intégrer média'
            },
            media: {
                image: 'Image',
                video: 'Vidéo',
                audio: 'Audio',
                embed: 'Intégré'
            }
        },
        finder: {
            remove: 'Supprimer',
            cancel: 'Annuler',
            confirm: 'Confirmer',
            insert: "insérer l'élément sélectionné",
            width: 'largeur',
            height: 'haut',
            image: 'Image',
            video: 'Vidéo',
            audio: 'Audio',
            embed: 'Intégrer média',
            caption: 'Bibliothêque',
            dragTip: 'Cliquez ou faites glisser le fichier ici',
            dropTip: 'Libérer pour télécharger',
            selectAll: 'tout sélectionner',
            deselect: 'annuler la sélection',
            removeSelected: "supprimer l'élément sélectionné",
            externalInputPlaceHolder:
                'Nom de la ressource|Adresse de la ressource',
            externalInputTip: `Utilisez "|" pour séparer le nom de la ressource et l'adresse de la ressource`,
            addLocalFile: 'Ajouter des ressources locales',
            addExternalSource: 'Ajouter une ressource Web',
            unnamedItem: 'projet sans titre',
            confirmInsert: "Insérer l'élément sélectionné"
        }
    }
}
